module.exports = __webpack_public_path__ + "static/media/ug.83393e5b.svg";